import { ChatAgentMessage } from "@components/ChatAgent";
import { Slide, useTheme } from "@mui/material";
import React from "react";
import { UserDadaType } from "@context/auth/types";
import AnimatedChatLoadingComponent from "@components/ChatAgent/components/AnimatedChatLoading/AnimatedChatLoading.component";
import {
  AvatarContainer,
  CheckMark,
  Container,
  MessageBox,
  MessageContainer,
  MessageMeta,
  Timestamp,
} from "@components/ChatAgent/components/ChatAgentMessageBox/style";
import ReactMarkdown from "react-markdown";

import { Bot, User } from "lucide-react";

interface ChatAgentMessageBoxProps {
  index: number;
  message: ChatAgentMessage;
  user?: UserDadaType;
}

const ChatAgentMessageBox = ({
  index,
  message,
  user,
}: ChatAgentMessageBoxProps) => {
  const theme = useTheme();
  const isAI = message.sender === "assistant";

  return (
    <Slide direction={"up"} in mountOnEnter unmountOnExit>
      <div>
        <Container isAI={isAI} messageIndex={index} gap={"10px"}>
          <AvatarContainer isAI={isAI}>
            {isAI ? (
              <Bot size={20} color="#000" />
            ) : (
              <User size={20} color="#fff" />
            )}
          </AvatarContainer>
          <MessageContainer theme={theme} isAI={isAI}>
            {message.response === "" ? (
              <AnimatedChatLoadingComponent />
            ) : (
              <MessageBox isAI={isAI}>
                <ReactMarkdown>{message.response}</ReactMarkdown>
              </MessageBox>
            )}
          </MessageContainer>
        </Container>
        {message.timestamp && (
          <MessageMeta isAI={isAI}>
            <Timestamp>{message.timestamp}</Timestamp>
            {!isAI && <CheckMark>{"✓✓"}</CheckMark>}
          </MessageMeta>
        )}
      </div>
    </Slide>
  );
};

export default ChatAgentMessageBox;
